import React from 'react';
import Stack from 'react-bootstrap/Stack';
import Spinner from 'react-bootstrap/Spinner';
import { APIClient, Name, Asset } from '@wharfkit/session';
import { ContractKit } from '@wharfkit/contract';

import { DEFAULT_BLOCKCHAIN, TOKEN_CONTRACT } from '../config';
import noImageFoundIcon from '../Assets/NoImageFoundIcon.png';
import './TokensList.css';

const client = new APIClient({url: DEFAULT_BLOCKCHAIN.url});
const contractKit = new ContractKit({client: client});

function TokensList() {
    const [listItems, setListItems] = React.useState(null);

    React.useEffect(() => {
        fetchTokenListItems()
            .then(items => setListItems(items))
            .catch(error => alert(error))
    }, []);

    return (
        <>
            {/* The list of tokens is being fetched */}
            { !listItems &&
                <div style={{textAlign: 'center', padding: '2em'}}>
                    <Spinner animation="border" size="lg" role="status" aria-hidden="true"/>
                </div>
            }

            {/* The list of tokens can be rendered out */}
            { !!listItems?.length &&
                <div className="Tokens-scrollableList">
                    {listItems}
                </div>
            }
        </>
    );
};

export default TokensList;

// Components
function ListItem(props) {
    return (
        <div className="Tokens-scrollableListItem">
            <Stack direction="horizontal" style={{height: '100%'}}>
                <img src={props.iconURL || noImageFoundIcon} width="38px" height="38px" className="icon" onError={(event => {
                    event.target.src = noImageFoundIcon;
                    event.onerror = null;
                })} alt="token-icon"/>
                
                <Stack direction="vertical" style={{margin: '0 8px 0 8px', alignSelf: 'center', minWidth: 0, flex: '1 1 33%'}}>
                    <div className="title">{props.name || props.symbol}</div>
                    <div className="subtitle">{props.issuer}</div>
                </Stack>
                
                <div className="rightDetail">{props.currentSupply}</div>
            </Stack>
        </div>
    );
};

// Helpers
async function fetchTokenListItems() {
    const tokens = await fetchExistingTokens();
    const items = tokens.map(token => {
        const tokenSymbol = token.maxSupply.symbol.code.toString();
        const supply = token.supply.toString().split(' ')[0];
        return <ListItem key={tokenSymbol} name={token.name} issuer={token.issuer.toString()} iconURL={token.iconURL} symbol={tokenSymbol} currentSupply={supply}/>;
    });
    
    return items;
};

async function fetchExistingTokens() {
    const symbols = await fetchScopedSymbols();
    const icons = await fetchTokenIcons();
    const contract = await contractKit.load(TOKEN_CONTRACT);
    const result = await contract.readonly('getstats', {symbols});

    return result.map(r => {
        const name = r['name'];
        const issuer = r['issuer'];
        const supply = Asset.from(r['supply']);
        const maxSupply = Asset.from(r['max_supply']);
        const symbol = supply.symbol.name.toString();
        const tokenDetails = icons.find(e => (e.chain === DEFAULT_BLOCKCHAIN.name.toLowerCase() && e.account === TOKEN_CONTRACT && e.symbol === symbol));
        const iconURL = tokenDetails?.logo;
        return {name, iconURL, issuer, supply, maxSupply};
    })
};

async function fetchScopedSymbols() {
    let symbols = [];
    let nextKey = null;

    do {
        const response = await client.v1.chain.get_table_by_scope({
            code: TOKEN_CONTRACT,
            table: 'stat',
            limit: 1000
        });

        const filteredSymbols = response.rows
            .map(row => row.scope.toString())
            .map(name => Asset.SymbolCode.from(Name.from(name).value).toString());

        nextKey = response['more']; // More results available
        symbols = symbols.concat(filteredSymbols);
    } while (nextKey);

    return symbols;
};

async function fetchTokenIcons() {
    const response = await fetch('https://raw.githubusercontent.com/eoscafe/eos-airdrops/master/tokens.json');
    return await response.json();
};